<micro-lookup domain="mail" obj="smtps" url="/mail/smtp" [key]="smtpMailboxId" [link]="link"></micro-lookup>
